import { useTranslation } from "react-i18next";
import { Box, Chip, Typography } from "@mui/material";
import { useNavigate, useSearchParams } from "react-router-dom";

import { getPlansRoute } from "../../../../routers/routeUtils";

const PlansPageHeader = () => {
  const navigate = useNavigate();
  const { t } = useTranslation("plans", { keyPrefix: "page.plansPage" });
  const [searchParams] = useSearchParams();
  const billing = searchParams.get("billing") ?? "monthly";

  const plans = ["monthly", "yearly"];

  return (
    <Box sx={styles.mainContent}>
      <Box sx={styles.headerContainer}>
        <Box sx={styles.headerTitleContainer}>
          <Typography variant="h5" sx={styles.pricingTitle}>
            {t("pricing")}
          </Typography>
          <Typography variant="h3" sx={styles.headerTitle}>
            {t("playYourWayGrowYourNetwork")}
          </Typography>
        </Box>
        <Typography sx={styles.headerDescription}>{t("smartPricingThatGrowsWithYourGoals")}</Typography>
      </Box>
      <Box sx={styles.plansContainer}>
        {plans.map((plan) => {
          const isCurrent = plan === billing;
          return (
            <Chip
              key={plan}
              label={
                // plan === "monthly" ? (
                //   t(plan)
                // ) : (
                //   <Box sx={styles.annuallyContainer}>
                //     <Typography sx={styles.annuallyTitle(isCurrent)}>{t(plan)}</Typography>
                //     <Chip key={plan} label={t("save20")} variant="outlined" sx={styles.save20Chip} />
                //   </Box>
                // )
                t(plan)
              }
              variant="outlined"
              sx={styles.chip(isCurrent)}
              onClick={() => navigate(getPlansRoute(plan as "monthly" | "yearly"))}
            />
          );
        })}
      </Box>
    </Box>
  );
};

export default PlansPageHeader;

const styles = {
  mainContent: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "32px",
  },
  headerContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "24px",
  },
  pricingTitle: {
    fontFamily: "Montserrat",
    color: "var(--Brand-700, #076D0D)",
    textAlign: "center",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "24px",
  },
  headerTitleContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "12px",
  },
  headerTitle: {
    color: "var(--Gray-900, #101828)",
    textAlign: "center",
    fontFamily: "Montserrat",
    fontSize: "40px",
    fontStyle: "normal",
    fontWeight: 750,
    lineHeight: "60px",
  },
  headerDescription: {
    fontFamily: "Montserrat",
    color: "var(--Gray-600, #475467)",
    textAlign: "center",
    fontSize: "20px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "30px",
  },
  plansContainer: {
    display: "flex",
    border: "1px solid var(--Gray-200, #E4E7EC)",
    backgroundColor: "var(--Gray-50, #F9FAFB)",
    height: "fit-content",
    width: "fit-content",
    borderRadius: "8px",
    boxShadow: "0 1px 2px 0 rgba(16, 24, 40, 0.05)",
    overflow: "hidden",
  },
  chip: (isCurrent: boolean) => ({
    fontFamily: "Montserrat",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "24px",
    padding: "8px 12px",
    color: isCurrent ? "var(--Gray-700, #344054)" : "var(--Gray-500, #667085)",
    backgroundColor: isCurrent ? "var(--Base-White, #FFF)" : "var(--Gray-50, #F9FAFB)",
    border: isCurrent ? "1px solid var(--Gray-300, #D0D5DD)" : "none",
    borderRadius: "8px",
    "& .MuiChip-label": {
      padding: 0,
    },
  }),
  annuallyContainer: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },
  annuallyTitle: (isCurrent: boolean) => ({
    fontFamily: "Montserrat",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "24px",
    color: isCurrent ? "var(--Gray-700, #344054)" : "var(--Gray-500, #667085)",
  }),
  save20Chip: {
    fontFamily: "Montserrat",
    color: "var(--Gray-700, #344054)",
    textAlign: "center",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 500,
    lineHeight: "20px",
    borderRadius: "16px",
    border: "1px solid var(--Gray-200, #E4E7EC)",
    background: "var(--Gray-50, #F9FAFB)",
    padding: "2px 10px",
    height: "fit-content",
    "& .MuiChip-label": {
      padding: 0,
    },
  },
};
